// @mui
import Collapse from '@mui/material/Collapse';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { usePathname } from 'src/routes/hook';
//
import { NavItemProps } from '../types';
import NavItem from './nav-item';

// ----------------------------------------------------------------------

type NavListProps = {
  item: NavItemProps;
};

export default function NavList({ item }: NavListProps) {
  const pathname = usePathname();

  const { path } = item;

  const externalLink = path ? path.includes('http') : undefined;

  const nav = useBoolean();

  const hasChild = item.children && item.children.length > 0;

  return (
    <>
      <NavItem
        item={item}
        open={nav.value}
        onClick={nav.onToggle}
        active={pathname === path}
        externalLink={externalLink}
      />
      {hasChild && (
        <Collapse in={nav.value} unmountOnExit>
          {item.children?.map((child) => (
            <NavItem
              key={child.title}
              item={child}
              open={nav.value}
              onClick={nav.onToggle}
              active={pathname === child.path}
              externalLink={child.path ? child.path.includes('http') : undefined}
            />
          ))}
        </Collapse>
      )}
    </>
  );
}
